/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryResponse,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityPathParams,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability401,
  GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability500,
} from "../../types/individualPaymentTraceabilityController/GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability } from "../../clients/individualPaymentTraceabilityController/getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability.ts";

export const getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryKey =
  (
    financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityPathParams["financialPersonId"],
  ) =>
    [
      {
        url: "/api/v1/individualpayment/financial-people/:financialPersonId/traceability",
        params: { financialPersonId: financialPersonId },
      },
    ] as const;

export type GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryKey =
  ReturnType<
    typeof getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryKey
  >;

export function getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryOptions(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityPathParams["financialPersonId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryKey(
      financialPersonId,
    );
  return queryOptions<
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability500
    >,
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryResponse,
    typeof queryKey
  >({
    enabled: !!financialPersonId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability(
        financialPersonId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna os registros de auditoria do plano (GA_TRACEABILITY, entidade CourseFinancialPerson). Migrado do legado IndividualPayment/LoadFinancialPersonTraceabilityGridDataAsync. **(Requer Authorization para autenticação)**
 * @summary Retorna a rastreabilidade (auditoria por campo) de um plano financeiro (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/traceability}
 */
export function useGetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability<
  TData =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryResponse,
  TQueryData =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryKey,
>(
  financialPersonId: GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityPathParams["financialPersonId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability401
          | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryKey(
      financialPersonId,
    );

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceabilityQueryOptions(
        financialPersonId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability401
      | GetApiV1IndividualpaymentFinancialPeopleFinancialpersonidTraceability500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
